<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="emOpcUaNodeInfoEouniResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName"
                        ref="emTable" import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                <template #left-header>
                  <em-button type="import"
                             custom-label="读取节点信息"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             :busy="onReadNodeInfo"
                             v-b-modal.modal-read-node-info
                  >
                  </em-button>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <b-modal id="modal-read-node-info" title="读取节点信息" hide-footer>
      <b-form @submit="handleReadNodeInfo" @reset="handleReadNodeInfoReset">
        <b-row class="my-1">
          <b-col sm="3">
            <label>服务名:</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="serverName" type="text" v-model="imfOpcNodeDto.serverName"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="3">
            <label>identifier:</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="identifier" type="text" v-model="imfOpcNodeDto.identifier"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="3">
            <label>namespaceIndex:</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="namespaceIndex" type="number" v-model="imfOpcNodeDto.namespaceIndex"></b-form-input>
          </b-col>
        </b-row>
        <b-row align-h="end" style="margin-top: 30px">
          <b-button type="submit" variant="primary">确定</b-button>
          <b-button type="reset" variant="danger">取消</b-button>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-06-21 17:50:20

import emCommonListMixin from "@/mixin/em/common/list";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emApiMixin from "@/mixin/em/common/api";

export default {
  name: "emOpcUaNodeInfoEouniListView",
  mixins: [emCommonListMixin,emApiMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      onReadNodeInfo: false,
      imfOpcNodeDto: {
        serverName: "",
        identifier: "",
        namespaceIndex: 0
      }
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    }
  },
  methods: {
    handleReadNodeInfo(event) {
      event.preventDefault()
      this.onReadNodeInfo = true
      this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("emOpcComputedEoc") + "/emOpcUaNodeInfoEouni/readNodeList", this.imfOpcNodeDto)
          .then(response => {
            console.log(response)
            let nodeNum = response.data.length
            commonViewsUtil.showSuccess(this, `成功读取到【${nodeNum}】条节点信息`)
            this.$refs.emListFilter.doQuery()
          }).finally(() => this.onReadNodeInfo = false);
      this.$nextTick(() => {
        this.$bvModal.hide('modal-read-node-info')
      })
    },
    handleReadNodeInfoReset() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-read-node-info')
      })
    },
  }
};
</script>